export const getCompanyUuid = () => {
  return localStorage.getItem("uuidCompany");
};

// 契約有の場合に自身の会社UUIDを返す。契約がない場合、nullを返す
export const getCompanyUuidwithContract = () => {
  let companyUuid = localStorage.getItem("uuidCompany")
  if(companyUuid)
  {
    const companyInfo = JSON.parse(localStorage.getItem("company"));
    const is_contract = (companyInfo?.contract_id == 1);
    if (is_contract ==false)
    {
      companyUuid = null;
    }
  }
  return companyUuid;
};
